import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { newFlow, oldFlow } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-163" data-mp="1jnl9e32nb94w">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="1oiiptv298krt">
        <SectionHeading id="solution-heading" eyebrow="Meet Your New Teaching System" title={<>
              Stop Starting <Accent data-id="element-166" data-mp="1ygf2iraubns1">From Zero.</Accent>
            </>} body="Cosmetology Instructor Ready™ organizes the essential knowledge and teaching resources into one structured system." data-id="element-165" data-mp="1tgakgwuaakzp" />

        <div className="mx-auto mt-12 flex max-w-2xl flex-col items-center" data-id="element-167" data-mp="27cxqdp47slhr">
          <FlowRow steps={oldFlow} tone="old" label="Without a system" data-id="element-168" data-mp="91h1p6wus6qf" />
          <span className="my-4 flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-169" data-mp="d20u5x6hem68">
            <ArrowDownIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-170" data-mp="o9oam4t9lbv" />
            Becomes
          </span>
          <FlowRow steps={newFlow} tone="new" label="With Cosmetology Instructor Ready™" data-id="element-171" data-mp="3n1rpa7pas1xg" />
        </div>

        <p className="mx-auto mt-10 max-w-xl text-center text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-172" data-mp="3i36ljyau7049">
          Less searching. Less preparation. More structured teaching.
        </p>

        <img src={MOCKUP_URL} alt="The complete Cosmetology Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[560px] object-contain lg:max-w-[780px]" style={{
        filter: 'drop-shadow(0 30px 36px rgba(91, 63, 176, 0.16))'
      }} data-id="element-173" data-mp="ely61l3l0ccp" />
      </div>
    </section>;
}
function FlowRow({
  steps,
  tone,
  label
}: {
  steps: string[];
  tone: 'old' | 'new';
  label: string;
}) {
  const isNew = tone === 'new';
  return <div className="w-full" data-id="element-174" data-mp="1lgf8c6tyjxun">
      <p className="sr-only" data-id="element-175" data-mp="1lgp09zykcf2z">{label}</p>
      <ol className={`grid grid-cols-4 gap-2 rounded-[18px] p-2 sm:gap-3 ${isNew ? 'bg-brand-cta/10 ring-1 ring-brand-cta/30' : 'bg-brand-paper'}`} role="list" data-id="element-176" data-mp="1lfm9ds18qcn2">
        {steps.map(step => <li key={step} className={`rounded-[12px] px-1 py-3 text-center font-body text-[12px] font-bold uppercase tracking-[0.12em] sm:text-[14px] sm:tracking-[0.16em] ${isNew ? 'bg-white text-brand-cta shadow-sm' : 'text-brand-charcoal/40 line-through decoration-brand-charcoal/30'}`} data-id="element-177" data-mp="xr329ftxg5wk">
            {step}
          </li>)}
      </ol>
    </div>;
}